import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { IconPipe, DesignationPipe } from './pipes/common.pipe';
import { from } from 'rxjs/observable/from';
import { pipe } from 'rxjs';

import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    IconPipe,
    DesignationPipe
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    IconPipe,
    DesignationPipe,
    NgxSpinnerModule
   ],
  providers: [ MenuItems ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/shared/shared.module.ts